// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  legKey: __t.string(),
  status: __t.string(),
  notes: __t.string(),
  samples: __t.u32(),
  fpsAvg: __t.f32(),
  fpsP05: __t.f32(),
  frameMsP50: __t.f32(),
  frameMsP95: __t.f32(),
  frameMsP99: __t.f32(),
  frameMsMax: __t.f32(),
  drawCallsAvg: __t.u32(),
  trianglesAvg: __t.u64(),
  trianglesMax: __t.u64(),
  pipelines: __t.u32(),
  heapMbAvg: __t.f32(),
  heapMbMax: __t.f32(),
  loafCount: __t.u32(),
  loafMsTotal: __t.f32(),
  gpuMsAvg: __t.f32(),
  censusJson: __t.string(),
  extrasJson: __t.string(),
};
